module.exports = __webpack_public_path__ + "static/media/card-project4.282e960f.jpg";